module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/095-pitcairn-islands-7cf27cf6859c69acbaa6ec0ba7b2dfa6.svg";